<template>
  <svg
    id="User-Side--Streamline-Nova"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <desc>User Side Streamline Icon: https://streamlinehq.com</desc>
    <path
      d="M3 22.8A1.2 1.2 0 0 0 4.2 24h9.6a1.2 1.2 0 0 0 1.2 -1.2v-1.2a1.2 1.2 0 0 1 1.2 -1.2h3.6a1.2 1.2 0 0 0 1.2 -1.2v-5.867h2S22 0 12.333 0 3 9.333 3 9.333z"
      fill="currentColor"
      stroke-width="1"
    />
  </svg>
</template>
